import Svg, {Circle, Defs, Mask, Rect} from "react-native-svg";

type Props = {
    radius: number,
}

export default function SvgCircleMask({radius}: Props) {
    return (
        <Svg height="100%" width="100%">
            <Defs>
                <Mask id="mask" x="0" y="0" height="100%" width="100%">
                    <Rect height="100%" width="100%" fill="#fff"/>
                    <Circle r={radius} cx="50%" cy="50%"
                            fill="black"
                    />
                </Mask>
            </Defs>
            <Rect height="100%" width="100%" fill="rgba(0, 0, 0, 0.5)" mask="url(#mask)"/>
        </Svg>
    );
}